<template>
  <div>
    <div class="content">
      <es-form>
        <template #es-form-header>
          <div class="header-container">
            <div class="header-elements">
              <h6 class="title">
                {{ locationPermission.role.name }}
              </h6>
            </div>
            <div class="header-actions">
              <div v-if="hasModule('SYS:SEC:USRMGR:EDIT')
                && adminMode && hasUserLocationAccess"
                class="list-content">
              <a
                v-if="!isEditAuthorization"
                :class="{ disabled:
                  currentEditPanel != ''
                  && currentEditPanel != 'editAuthorization'
                  || !hasRoleAccess(locationPermission.role.id)
                  || isCurrentUser }"
                :tabindex="currentEditPanel !=''
                  && currentEditPanel != 'editAuthorization'
                  || !hasRoleAccess(locationPermission.role.id) ? -1 : 0"
                role="button"
                @click="editRoles()"
                @keypress.enter="editRoles()"
              >
                <font-awesome-icon :icon="['fas', 'edit']" size="lg" title="Edit" />
            </a>
            <a v-if="!isEditAuthorization"
              style= "margin-left:.75rem"
              :class="{ disabled:
                currentEditPanel != ''
                && currentEditPanel != 'editAuthorization'
                || primaryRole
                || !hasRoleAccess(locationPermission.role.id) }"
              :tabindex="currentEditPanel != ''
                && currentEditPanel != 'editAuthorization'
                || primaryRole
                || !hasRoleAccess(locationPermission.role.id)? -1 : 0"
              role="button"
              @click="toggleModal()"
              @keypress.enter="toggleModal()"
            >
              <font-awesome-icon :icon="['fas', 'trash-alt']" size="lg" title="Delete" />
          </a>
        </div>
      </div>
    </div>
  </template>
  <template #es-form>
    <div class="row" :class="{ removeUnderline: isEditing }">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Role</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input class="input is-static"
                :class="{'is-readonly' : isEditing}"
                readonly
                :value="locationPermission.role.name"
                :aria-label="locationPermission.role.name || 'Role'"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" :class="{ removeUnderline: isEditing }">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">
            District
          </label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input class="input"
                :class="{'is-static' : !isEditing }"
                type="text"
                v-model="districtType"
                :readonly="!isEditing"
                v-if="!isEditing"
                :aria-label="districtType || 'District'"
                />
              <div v-if="isEditing " class="buttons has-addons">
                  <button v-for="(option, index) in districtOptions" :key="index"
                  :disabled = "option.name === 'All Districts' ? !isStateUser : false"
                  class="button no-radius"
                  :class="{'selected-type': districtType === option.name}"
                  @click="selectedType('districtType', option.name)">
                {{ option.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div v-if="districtType === 'Specific Districts'" class="row"
  :class="{ removeUnderline: isEditing }">
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label" for="formEditDistrictControl">
        District(s)
      </label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <span class="tags" v-if="!isEditing " >
            <strong class="tag" v-for="(item, index) in locationPermission.districts"
              :key="index">
              {{ item.district.location.name }}
            <span class="text-codes has-text-grey"> ({{ item.code }})</span>
            </strong>
        </span>
        <div v-if="isEditing">
          <es-select
            :class="{'is-danger': hasErrorDistrict }"
            v-bind:multi="true"
            v-bind:search="true"
            api="districts"
            v-on:update:values="districts = $event"
            ref="selDistricts"
            :valueTplFn="(result) => `${result.location.name} (${result.code})`"
            :preSelected="preSelectedDistricts"
            searchMinLength="2"
            keyValue="code"
            controlId="formEditDistrictControl"
          />
        </div>
      </div>
      <span v-if="hasErrorDistrict" class="help is-danger">
        {{ msgDistrict }}
      </span>
    </div>
  </div>
</div>
    </div>
    <div class="row" :class="{ removeUnderline: isEditing }">
<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label class="label">School</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input class="input"
          :class="{'is-static' : !isEditing }"
          type="text"
          v-model="schoolType"
          :readonly="!isEditing "
          v-if="!isEditing"
          :aria-label="schoolType || 'School'"/>
          <input class="input"
            :class="{'is-static' : isEditing }"
            type="text"
            v-model="schoolType"
            :aria-label="schoolType || 'School'"
            :readonly="isEditing "
            v-if="isEditing && districtType === 'All Districts'" />
            <div v-if="isEditing && districtType === 'Specific Districts'"
              class="buttons has-addons">
              <button v-for="(option, index) in schoolOptions" :key="index"
              :disabled="(!districts.length) || (districts.length && option.name === 'All Schools' ? userSchools.length !== 0 : false)"
                class="button no-radius"
                :class="{'selected-type': schoolType === option.name}"
                @click="selectedType('schoolType', option.name)">
                {{ option.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div v-if="schoolType === 'Specific Schools'" class="row"
  :class="{ removeUnderline: isEditing }">
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label" for="formEditSchoolControl">School(s)</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <span class="tags" v-if="!isEditing" >
              <strong class="tag"
                v-for="(item, index) in locationPermission.schools"
                :key="index">
                  {{ item.school.location.name }}
                <span class="text-codes has-text-grey"> ({{ item.code }})</span>
              </strong>
            </span>
            <div v-if="isEditing">
              <es-select
                :class="{ 'is-danger': hasErrorSchool }"
                v-bind:multi="true"
                v-bind:search="true"
                api="schools"
                :apiQueryParams="getDistrictParams"
                v-on:update:values="schools = $event"
                ref="selSchools"
                :valueTplFn="(result) => `${result.location.name} (${result.code})`"
                :subValueTplFn="(result) => `${result.districtLocation.name}
                (<i>${result.districtCode }</i>)`"
                :preSelected="schoolCodesPromises"
                searchMinLength="2"
                keyValue="code"
                controlId="formEditSchoolControl"
              />
            </div>
          </div>
          <span v-if="hasErrorSchool" class="help is-danger">
            {{ msgSchool }}
          </span>
        </div>
      </div>
    </div>
    </div>
  <div v-if="showMatchTypes">
    <div class="row" :class="{ removeUnderline: isEditing }">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label" for="formEditMatchTypeControl">DirectMatch Match Type(s)</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <span class="tags" v-if="!isEditing">
                <strong class="tag"
                  v-for="(matchType, index) in locationPermission.programs"
                  :key="index">
                {{ matchType.program.description }}
                </strong>
            </span>
            <div v-if="isEditing">           
              <es-select
                v-bind:multi="true"
                v-on:update:values="programs = $event;"     
                :setValues="filterProgramsByPersonType"
                :value-tpl-fn="(result) => `${result.description}`"
                :preSelected="preSelectedPrograms"
                keyValue="code"
                v-bind:clearOut="true"
                controlId="formEditMatchTypeControl"
              />
              <div class="form-subtext has-text-left">
                Match Type allows the user to access to specific match types
                throughout the application.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <div class="row" :class="{ removeUnderline: isEditing }">
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Location Group</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <input class="input"
              :class="{'is-static': !isEditing }"
              type="text"
              v-model="locationGroupType"
              :aria-label="locationGroupType || 'Location Group'"
              :readonly="!isEditing "
              v-if="!isEditing "/>
            <div v-if="isEditing " class="buttons has-addons">
              <button v-for="(option, index) in locationGroupOptions"
                :disabled="isDisabled(option)"
                :key="index"
                class="button no-radius"
                :class="{'selected-type': locationGroupType === option}"
                @click="selectedType('locationGroupType', option)">
                  {{ option }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="locationGroupType === 'Specific Groups'" class="row"
   :class="{ removeUnderline: isEditing }">
   <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label" for="formEditGroupControl">Location Group(s)</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <span class="tags" v-if="!isEditing " >
              <strong class="tag"
                v-for="( group, index ) in locationPermission.locationGroups"
                :key="index">
                  {{ group.locationGroup.description}}
                </strong>
              </span>
                <div v-if="isEditing">
                  <es-select
                    :class="{ 'is-danger': hasErrorLocationGroup }"
                    v-bind:multi="true"
                    v-bind:search="true"
                    api="location-groups"
                    :apiQueryParams="locationGroupQueryParams"
                    v-on:update:values="locationGroups = $event"
                    ref="selGroups"
                    valueTpl="${label}"
                    :preSelected="locationGroups"
                    searchMinLength="3"
                    keyValue="id"
                    controlId="formEditGroupControl"
                  />
                </div>
                  </div>
                  <span v-if="hasErrorLocationGroup" class="help is-danger">
                    {{ msgLocationGroup }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </es-form>
    </div>
    <div class="es-actions" v-if="isEditing ">
      <es-form-actions>
        <template #form-actions>
          <div class="bottom-content">
            <ul>
              <li>
                <div class="list-content">
                  <a tabindex="0" role="link"
                    @click.prevent="cancelEdit()"
                    @keypress.enter.prevent="cancelEdit()"
                  >Cancel</a>
                </div>
              </li>
              <li>
                <div class="list-content">
                  <button
                  class="button is-primary"
                  @click.prevent="updateAuthorization()">
                  Update
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </es-form-actions>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import EsForm from '@/components/EsForm.vue';
import PermissionManager from '@/mixins/PermissionManager';
import RolePermissions from '@/mixins/RolePermissions';
import EsSelect from '@/components/EsSelect.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import NotificationManager from '@/mixins/NotificationManager';
import FieldLabels from '@/mixins/FieldLabels';

export default {
  mixins: [
    PermissionManager,
    NotificationManager,
    RolePermissions,
    FieldLabels,
  ],
  components: {
    EsSelect,
    EsForm,
    EsFormActions,
  },
  props: [
    'locationPermission',
    'currentEditPanel',
    'isEditAuthorization',
    'filterProgramsByPersonType',
    'userId',
    'adminMode',
    'primaryRole',
    'isCurrentUser',
    'isStateUser',
    'roles',
  ],

  data() {
    return {
      isEditing: false,
      initialState: null,
      apiQueryParams: { active: 'true' },
      locationGroupQueryParams: { status: 'true' },
      roleId: null,
      districts: this.locationPermission.districts.map(d => ({ code: d.code, location: { name: d.district.location.name } })),
      schools: this.locationPermission.schools.map(s => ({ districtCode: s.districtCode, code: s.code, location: { name: s.school.location.name } })),
      locationGroups: this.locationPermission.locationGroups.map(g => ({ id: g.locationGroupId, label: g.locationGroup.description })),
      programs: this.locationPermission.programs.map(p => ({ code: p.programCode, description: p.program.description })),
      districtOptions: [],
      districtType: null,
      schoolOptions: [],
      schoolType: 'All Schools',
      locationGroupOptions: ['All Groups', 'Specific Groups', 'No Groups'],
      locationGroupType: 'All Groups',
      hasErrorDistrict: false,
      hasErrorSchool: false,
      hasErrorLocationGroup: false,
      msgWarning: false,
      msgDistrict: '',
      msgSchool: '',
      msgLocationGroup: '',
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
    };
  },
  watch: {
    districtType() {
      if (this.districtType === 'All Districts') {
        this.schoolType = `All Schools`;
      } else {
        this.districts = this.locationPermission.districts.map(d => ({ code: d.code, location: { name: d.district.location.name } }));
      }
    },
    districts() {
      if (this.districts.length && this.hasErrorDistrict) {
        this.hasErrorDistrict = false;
        this.hideErrorNotification();
      }
    },
    schools() {
      if (this.schools.length && this.hasErrorSchool) {
        this.hasErrorSchool = false;
        this.hideErrorNotification();
      }
    },
    locationGroups() {
      if (this.locationGroups.length && this.hasErrorLocationGroup) {
        this.hasErrorLocationGroup = false;
        this.hideErrorNotification();
      }
    },
  },
  created() {
    this.districtOptions= [
      {
        name: 'All Districts',
        label: `All Districts`,
      },
      {
        name: 'Specific Districts',
        label: `Specific Districts`,
      },
    ];
    this.schoolOptions= [
      {
        name: 'All Schools',
        label: `All Schools`,
      },
      {
        name: 'Specific Schools',
        label: `Specific Schools`,
      },
    ];
    if (this.isStateUser) {
      this.districtType = `All Districts`;
    } else {
      this.districtType = `Specific Districts`;
    }
    if (!this.userSchools.length) {
      this.schoolType = `All Schools`;
    } else {
      this.schoolType = `Specific Schools`;
    }
    if (!this.userLocationGroups) {
      this.locationGroupType = 'All Groups';
    } else if (this.locationGroups.length && this.locationGroups.find(x => x.id === -1)) {
      this.locationGroupType = 'No Groups';
    } else {
      this.locationGroupType = 'Specific Groups';
    }
  },
  mounted() {
    this.getSelectedOptions();
    this.checkPermissions();
  },
  computed: {
    ...mapGetters({
      userDistricts: 'userDistricts',
      userSchools: 'userSchools',
      hasAllGroupAccess: 'hasAllGroupAccess',
      hasSpecificGroupAccess: 'hasSpecificGroupAccess',
    }),
    // TODO: get ride of these computed preSelects. Just use the data element.
    preSelectedDistricts() {
      if (this.locationPermission.districts.length) {
        return this.locationPermission.districts.map(d => ({ code: d.code, location: { name: d.district.location.name } }));
      }
    },
    schoolCodesPromises() {
      if (this.locationPermission.schools.length) {
        return this.locationPermission.schools.map(s => ({ districtCode: s.districtCode, code: s.code, location: { name: s.school.location.name } }));
      }
    },
    preSelectedPrograms() {
      if (this.locationPermission.programs.length) {
        return this.locationPermission.programs.map(p => ({ code: p.programCode, description: p.program.description }));
      }
    },
    getDistrictParams() {
      const params = {};
      params.districtCode = this.districts.map(d => d.code);
      return params;
    },
    districtCodes() {
      return this.locationPermission.districts.map(d => d.code);
    },
    locationGroupCodes() {
      return this.locationPermission.locationGroups.map(g => g.locationGroupId);
    },
    programCodes() {
      return this.locationPermission.programs.map(p => p.programCode);
    },
    hasDistrictAccess() {
      if (!this.isStateUser && this.userDistricts.length) {
        const userDistrictCodes = this.userDistricts.map(d => d.code);
        if (this.districtCodes.length) {
          return this.districtCodes.every(elem => userDistrictCodes.includes(elem));
        } else {
          return false;
        }
      }
      return true;
    },
    hasSchoolAccess() {
      if (this.userSchools.length) {
        const userSchoolCodes = this.userSchools.map(s => s.code);
        if (this.locationPermission.schools.length) {
          return this.locationPermission.schools
            .map(s => s.code)
            .every(elem => userSchoolCodes.includes(elem));
        } else {
          return false;
        }
      }
      return true;
    },
    hasUserLocationAccess() {
      return this.isStateUser ? true : this.hasDistrictAccess && this.hasSchoolAccess;
    },
    hasError() {
      return this.hasErrorDistrict || this.hasErrorSchool || this.hasErrorLocationGroup;
    },
  },
  methods: {
    isDisabled(option) {

      if (option === 'All Groups') {
        return !this.hasAllGroupAccess;
      }
      
      if (option === 'Specific Groups') {
        return !(this.hasSpecificGroupAccess || this.hasAllGroupAccess);
      }

      if (option === 'No Groups') {
        return !(this.hasSpecificGroupAccess || this.hasAllGroupAccess) && !(this.locationGroupType === option);
      }

      return false;
    },
    checkPermissions() {
      this.hasRolePermissions(this.locationPermission.roleId);
    },
    hasRoleAccess(id) {
      return this.roles.find(role => role.id === id);
    },
    hideErrorNotification() {
      if (!this.hasError) {
        this.hideNotification();
      }
    },
    getSelectedOptions() {
      if (this.locationPermission.districts && this.locationPermission.districts.length) {
        this.districtType = `Specific Districts`;
      } else {
        this.districtType = `All Districts`;
      }
      if (this.locationPermission.schools && this.locationPermission.schools.length) {
        this.schoolType = `Specific Schools`;
      } else {
        this.schoolType = `All Schools`;
      }
      if (this.locationPermission.locationGroups && this.locationPermission.locationGroups.length) {
        if (this.locationPermission.locationGroups.find(x => x.locationGroupId === -1)) {
          this.locationGroupType = 'No Groups';
        } else {
          this.locationGroupType = 'Specific Groups';
        }
      } else {
        this.locationGroupType = 'All Groups';
      }
    },
    selectedType(field, option) {
      if (field === 'districtType') {
        if (option === 'All Districts') {
          if (this.schools.length && !this.hasError) {
            this.showWarning('Data has been removed from the School(s) field based on the changes to the District(s) field.');
            this.msgWarning = true;
          }
          this.$refs.selDistricts.clear();
          if (this.schoolType === 'Specific Schools') {
            this.$refs.selSchools.clear();
          }
          this.hasErrorDistrict = false;
          this.msgDistrict = '';
        }
        this.districtType = option;
      }
      if (field === 'schoolType') {
        if (option === 'All Schools') {
          this.$refs.selSchools.clear();
          this.hasErrorSchool = false;
          this.msgSchool = '';
        } else {
          this.schools = this.locationPermission.schools.map(s => ({ districtCode: s.districtCode, code: s.code, location: { name: s.school.location.name } }));
        }
        this.schoolType = option;
      }
      if (field === 'locationGroupType') {
        if (option === 'All Groups') {
          this.$refs.selGroups ? this.$refs.selGroups.clear() : this.locationGroups = [] ;
          this.hasErrorLocationGroup = false;
          this.msgGroup = '';
        }
        else if (option === 'No Groups') {
          this.locationGroups = [{ id: -1 }];
          this.hasErrorLocationGroup= false;
          this.msgLocationGroup= '';
        }
        else if (option === 'Specific Groups') {
          this.locationGroups = this.locationGroups.filter( lg => lg.id !== -1);
        }
        this.locationGroupType = option;
      }
      if (!this.msgWarning && !this.hasError) {
        this.hideNotification();
      }
      this.msgWarning = false;
    },

    editRoles() {
      this.isEditing = true;
      this.saveInitialState();
      this.$emit('editPanel', 'editAuthorization');
    },
    saveInitialState() {
      this.initialState = {
        districts: [...this.districts],
        schools: [...this.schools],
        locationGroups: [...this.locationGroups],
        programs: [...this.programs],
        districtType: this.districtType,
        schoolType: this.schoolType,
        locationGroupType: this.locationGroupType,
      };
    },
    resetToInitialState() {
      if (this.initialState) {
        this.districts = [...this.initialState.districts];
        this.schools = [...this.initialState.schools];
        this.locationGroups = [...this.initialState.locationGroups];
        this.programs = [...this.initialState.programs];
        this.districtType = this.initialState.districtType;
        this.schoolType = this.initialState.schoolType;
        this.locationGroupType = this.initialState.locationGroupType;
      }
    },
    toggleModal() {
      this.roleId = this.locationPermission.roleId;
      this.$emit('openModal', this.roleId);
    },
    async updateAuthorization() {
      if (this.formValidation()) {
        this.showError(this.formErrorMsg);
        return;
      }
      this.hideNotification();
      try {
        let districtsList = this.districts.map(val => ({ code: val.code }));
        if (districtsList.length === 0) {
          districtsList = [{ code: 'ALL_LOCATIONS' }];
        }
        let schoolsList = this.schools.map(val => ({ code: val.code, districtCode: val.districtCode }));
        if (schoolsList.length === 0) {
          schoolsList = districtsList.map(val => ({ code: 'ALL_LOCATIONS', districtCode: val.code }));
        }

        const payload = {
          role: this.locationPermission.role,
          roleId: this.locationPermission.roleId,
          districts: districtsList,
          schools: schoolsList,
          locationGroups: this.locationGroups.map(val => ({ locationGroupId: val.id })),
          programs: this.programs.map(val => ({ programCode: val.code })),
        };
        await axios.put(`/users/${this.userId}/locationpermissions/${this.locationPermission.roleId}`, payload);
        this.showSuccess('The user authorization has been updated successfully.');
        this.isEditing = false;
        this.$emit('reloadAuthorizationPanel');
      } catch (error) {
        const { status } = error.response;
        let apiMsg = '';
        if (status === 500) {
          apiMsg = 'Network Error';
        } else if (status === 400) {
          apiMsg = `${error.response.data.message}`;
        } else if (status === 403) {
          apiMsg = 'User Does Not Have Access To This Resource.';
        } else {
          apiMsg = 'Something went wrong.';
        }
        this.showError(apiMsg);
      }
    },
    formValidation() {
      this.resetFormErrors();
      let error = 0;
      if (this.districtType === 'Specific Districts') {
        if (!this.districts || !this.districts.length) {
          this.hasErrorDistrict = true;
          this.msgDistrict = 'District is required';
          error += 1;
        }
      }
      if (this.schoolType === 'Specific Schools') {
        if (!this.schools || !this.schools.length) {
          this.hasErrorSchool = true;
          this.msgSchool = 'School is required';
          error += 1;
        }
      }
      if (this.schoolType === 'Specific Schools') {
        if (this.schools.length) {
          const isSchoolSelected = this.districts.map(item => item.code)
            .every(item => this.schools
              .map(item => item.districtCode)
              .includes(item));
          if (!isSchoolSelected) {
            this.hasErrorSchool = true;
            this.msgSchool = 'Please select at least one school for each selected district(s)';
            error += 1;
          }
        }
      }
      if (this.locationGroupType === 'Specific Groups') {
        if (!this.locationGroups || !this.locationGroups.length) {
          this.hasErrorLocationGroup = true;
          this.msgLocationGroup = 'Location Group is required.';
          error += 1;
        }
      }
      return error;
    },
    cancelEdit() {
      this.isEditing = false;
      this.resetToInitialState(); 
      this.getSelectedOptions();
      this.resetFormErrors();
      this.$emit('clearAll', 'editAuthorization');
    },
    resetFormErrors() {
      this.hasErrorDistrict = false;
      this.hasErrorSchool = false;
      this.hasErrorLocationGroup = false;
      this.msgDistrict = '';
      this.msgSchool = '';
      this.msgLocationGroup = '';
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    showSuccess(error) {
      this.showNotification('success', [error]);
    },
    showWarning(error) {
      this.showNotification('warning', [error]);
    },
  },
};

</script>
  <style lang="sass" scoped>
  .header-container
    margin-left: 2rem
    margin-bottom: 1rem
  .selected-type
    background-color: #ccc
    font-weight: bold
  a.disabled
    color: #999
    cursor:  default
    text-decoration:  none
    pointer-events: none
    &:hover
      text-decoration:  none
  .form-subtext
    color: #757575
    font-style: italic
    font-size: .85rem
  .text-codes
    font-style: italic
    font-weight: normal
    padding-left: 3px
  .invalid-feedback
    font-style: italic
    color: #dc3545
    font-size: .8rem
    padding: .25rem 0 .25rem .15rem
  .is-readonly
    /* background: #eee */
  </style>
